import React, { useCallback, useContext, useEffect } from "react";
import { IntersectionContext } from "../components/managers";
import useData from "./useData";

const useIntersection = ({ target, disable = false } = {}) => {
	const { observer } = useContext(IntersectionContext);
	const { canTrack } = useData();
	const observeEntity = useCallback(
		(target) => {
			if (!target) {
				console.warn("Invalid target passed for observation");
				return;
			}
			observer.current.observe(target);
		},
		[observer]
	);

	const unobserveEntity = useCallback(
		(target) => {
			if (!target) {
				console.warn("Invalid target passed for un-observation");
				return;
			}
			observer.current.unobserve(target);
		},
		[observer]
	);

	useEffect(() => {
		if (!target || disable || !canTrack) return;
		observeEntity(target);
		return () => {
			unobserveEntity(target);
		};
	}, [target, observeEntity, unobserveEntity, disable, canTrack]);
};

export default useIntersection;
